
import { defineComponent, ref, computed, watch, onUnmounted, getCurrentInstance, onMounted, PropType } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';
import Loading from '../loading-dark/index.vue';
import { sendLog } from '@/common/radar';
import { roundingNum } from '@/common/utils';
import { getTemplateConfig } from './template.config';

export default defineComponent({
    components: {
        vanActionSheet: ActionSheet,
        Loading,
    },
    props: {
        show: Boolean,
        lists: {
            type: Array as PropType<Record<string, any>>,
            default: () => [],
        },
        photoId: {
            type: String,
            default: '',
        },
        showIndex: {
            type: Number,
            default: () => 0,
        },
        loading: {
            type: Boolean,
            defalult: false,
        },
    },
    emits: ['userPageChangeQuery', 'update:show'],
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const showProps = computed({
            get: () => props.show,
            set: (value: boolean) => {
                return ctx.emit('update:show', value);
            },
        });

        const handleClose = () => {
            showProps.value = false;
        };

        const duration = ref(0);
        const startClock = ref(0);
        watch(
            () => [showProps.value, props.photoId],
            ([show, photoId], [prevShow, prevId]) => {
                if (photoId !== prevId) {
                    duration.value = 0;
                    startClock.value = 0;
                }
                if (show && !prevShow && startClock.value === 0) {
                    startClock.value = Date.now();
                }
                if (!show && prevShow) {
                    duration.value += Date.now() - startClock.value;
                    startClock.value = 0;
                }
            }
        );
        onUnmounted(() => {
            if (startClock.value !== 0) {
                duration.value += Date.now() - startClock.value;
                startClock.value = 0;
            }
        });

        const headerClickHandle = async (params: Record<string, any>) => {
            proxy.$router.push({ path: `/@${params?.kwaiid}` });

            ctx.emit('userPageChangeQuery');
        };

        function formatDateDiffToNow(millisecondsTimestamp: number) {
            const inputDate = new Date(millisecondsTimestamp) as any; // 使用毫秒级别的时间戳
            const now = new Date() as any;
            const diffMilliseconds = now - inputDate;
            const diffSeconds = Math.floor(diffMilliseconds / 1000);
            const diffMinutes = Math.floor(diffSeconds / 60);
            const diffHours = Math.floor(diffMinutes / 60);
            const diffDays = Math.floor(diffHours / 24);
            if (diffSeconds < 60) {
                return 'Just now';
            }
            if (diffMinutes < 60) {
                return `${diffMinutes}m ago`;
            }
            if (diffHours < 24) {
                return `${diffHours}h ago`;
            }
            if (diffDays < 7) {
                if (now.getFullYear() === inputDate.getFullYear()) {
                    return `${diffDays}d ago`;
                }
            } else if (diffDays < 365) {
                return inputDate.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit' }).replaceAll('/', '-');
            } else {
                return inputDate.toLocaleDateString({ year: 'numeric', month: '2-digit', day: '2-digit' }).replaceAll('/', '-');
            }
        }
        watch(
            () => props.show,
            newVal => {
                if (newVal) {
                    sendLog({
                        type: 'show',
                        name: 'COMMENT_PANEL',
                    });
                }
            }
        );
        onMounted(() => {
            // sendLog({
            //   type: 'show',
            //   name: 'COMMENT_PANEL'
            // })
        });

        return {
            showProps,
            duration,
            handleClose,
            roundingNum,
            headerClickHandle,
            formatDateDiffToNow,

            templateConfig: getTemplateConfig(),
        };
    },
});
